import Icon from '../components/Icon.vue'

Icon.register({"hand-point-left":{"width":512,"height":512,"paths":[{"d":"M44.8 155.8H194C188.2 147.6 183.5 139.3 179.9 130.9 166.2 99.1 189.8 64 224 64 242.6 64 256.2 74.9 264 93.1 276.1 121.4 342.6 157.4 371.5 170.4 389.4 178.4 400 195.9 400 214.3L400 214.3V385.8C400 397.6 391.4 407.7 379.7 409.5 332.9 416.7 318 448 256 447.8 253.3 447.8 242.7 448 240 448 189.3 448 158.4 425.9 167.4 376.7 148.8 367.4 136.7 337.3 150.9 314.4 126.3 293.2 128.3 260.5 144.7 243.5H44.8C20.6 243.5 0 223.3 0 199.7 0 176.4 21.4 155.8 44.8 155.8zM440 176H488C501.3 176 512 186.7 512 200V392C512 405.3 501.3 416 488 416H440C426.7 416 416 405.3 416 392V200C416 186.7 426.7 176 440 176zM464 388C475 388 484 379 484 368S475 348 464 348 444 357 444 368 453 388 464 388z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-point-left.js
// module id = null
// module chunks = 